import * as React from 'react';
import { SubareaInput } from '../../../schema';
import { TSInput } from '../../common/TSInput';
import { Row, Col } from 'antd';
import { Label } from '../../common/TSLabel';
import { AreaDropDown } from '../Area/AreaDropdown';

export const SubareaForm: React.FunctionComponent<Props> = (props) => {
  return (
    <div>
      <Row>
        <Col span={8}>
          <TSInput
            error=""
            value={props.subarea.name}
            type="text"
            name="name"
            onChange={props.onChange}
            addonBefore="Name"
          />
        </Col>
        <Col span={8}>
          <TSInput
            error=""
            value={props.subarea.pincode}
            type="number"
            name="pincode"
            onChange={props.onChange}
            addonBefore="Pin Code"
          />
        </Col>
        <Col span={8}>
          <Label title="Area">
            <AreaDropDown
              onSelect={(e, f) => {
                props.onChange({
                  target: { name: 'areaId', value: String(e) },
                });
              }}
              value={props.subarea.areaId}
              allowClear
            />
          </Label>
        </Col>
      </Row>
    </div>
  );
};

interface Props {
  subarea: SubareaInput;
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => void;
}
